// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".text_block[data-v-1cccbbb8] {\n  display: inline-block;\n  font-size: 12pt;\n  color: #606226;\n}\n.right_margin[data-v-1cccbbb8] {\n  margin-right: 30px;\n}\n.w150[data-v-1cccbbb8] {\n  width: 150px;\n}\n.w250[data-v-1cccbbb8] {\n  width: 250px;\n}\n.white_color[data-v-1cccbbb8] {\n  color: #FFF;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
